module.exports = __webpack_public_path__ + "static/media/addPorject.e0e58cd8.png";